import PropTypes from 'prop-types';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

interface CharPreviewProps {
  char: string;
  selectChar: (args: {char: string; insert: boolean}) => void;
}

class CharPreview extends React.PureComponent<CharPreviewProps> {
  static propTypes = {
    char: PropTypes.string.isRequired,
    selectChar: PropTypes.func.isRequired,
  };

  static previewableChar(char: string): string {
    switch (char) {
      case ' ':
        return '\u00A0'; // Replace space with nbsp for rendering, otherwise weird collapsing occurs.
      default:
        return char;
    }
  }

  onClick = (): void => {
    this.props.selectChar({char: this.props.char, insert: false});
  };

  onDoubleClick = (): void => {
    this.props.selectChar({char: this.props.char, insert: true});
  };

  render(): JSX.Element {
    return (
      <div
        className="charPreview pull-left u-pointer"
        onClick={this.onClick}
        onDoubleClick={this.onDoubleClick}
        {...getTestProps({component: 'CharPreview', element: 'root', key: this.props.char})}
      >
        {CharPreview.previewableChar(this.props.char)}
      </div>
    );
  }
}

export default CharPreview;
